import React, { useEffect, useState } from'react';

export const MenuMap = ({menuGroups, selectedItem, onSelectedItem, address}) => {
    const [activeMenuGroupService, setActiveMenuGroupService] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if(selectedItem.id && !selectedItem.disabled && menuGroups && menuGroups[0].subGroups){
            menuGroups.map(group => {
                let groupItemsIds = group.subGroups.flatMap(subGroup => subGroup.items.map(i => i.id));
                if(groupItemsIds.includes(selectedItem.id)){
                    setActiveMenuGroupService(group.label);
                }
            })
        }
    }, [selectedItem]);

    const selectItem = (item) => {
        setIsOpen(false);
        onSelectedItem(item);
    };

    return (
        <div className={`dashboard-infos ${isOpen ? 'dashboard-infos--open' : ''} `}>
            <div className="block-collapse-edito--main block-collapse-edito bg-white">
                <button class="menu-toggle border-bottom collapsed w-100 d-xl-none" onClick={() => setIsOpen(!isOpen)} title="Menu">
                    <span className="collapse-handler mx-auto rounded-pill border py-0">{isOpen ? 'Voir moins' : 'Voir plus'}</span>
                </button>
                <div className="edito--main-list collapse show">
                    <div className="collapse-content p-0">
                        {menuGroups.length > 0 &&
                            menuGroups.map((group, menuGroupIndex) =>
                                <div className="block-collapse-edito bg-white rounded-0 border-0" key={`menuGroup-${menuGroupIndex}`}>
                                    <button
                                        className="collapse-handler"
                                        data-target={`#collapse-${menuGroupIndex}`}
                                        data-toggle="collapse"
                                        aria-expanded="true"
                                        type="button">
                                        <h2><strong>{group.label}</strong></h2>
                                    </button>
                                    <div className='collapse show' id={`collapse-${menuGroupIndex}`}>
                                        <div className="collapse-content">
                                            {group.items &&
                                                <div className="field-item -form-check-version2 -horizontal">
                                                    {group.items.map(i =>
                                                        <div className="item" key={i.id}>
                                                            <input id={`${i.id}-input`} type="radio" name='elements' checked={selectedItem.id === i.id} onClick={()=> selectItem(i)} disabled={i.disabled||false}/>
                                                            <label htmlFor={`${i.id}-input`} className='border-0 rounded-0'>
                                                                <span className='wrapper-content'>{i.label}</span>
                                                            </label>
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                            {group.subGroups &&
                                                group.subGroups.map((subGroup, subGroupIndex) =>
                                                    <div key={`subGroup-${subGroupIndex}`}>
                                                        <p>{subGroup.label}</p>
                                                        <div className="field-item -form-check-version2 -horizontal">
                                                            {subGroup.items.map((item, index) =>
                                                                <div className="item" id='item.id' key={`service-${index}`}>
                                                                    <input id={`input-${menuGroupIndex}-${subGroupIndex}-${index}`} type="radio" name='elements' checked={selectedItem.id === item.id} onClick={()=> selectItem(item)}/>
                                                                    <label htmlFor={`input-${menuGroupIndex}-${subGroupIndex}-${index}`} className='border-0 rounded-0'>
                                                                        <span className='wrapper-content'>{item.label}</span>
                                                                    </label>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}